import { render, staticRenderFns } from "./DisputesHistory.vue?vue&type=template&id=086208d5"
import script from "./DisputesHistory.vue?vue&type=script&lang=js"
export * from "./DisputesHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports